import { useEffect, useRef, useState } from "react";
import { IdentityChrome } from "./IdentityChrome";
import { SiteMenuOverlay } from "./SiteMenuOverlay";
import { PRIMARY_MENU_LINKS } from "@/config/siteRoutes";
import { applyChromeSplitTone } from "@/utils/chromeSplitTone";
import "@/styles/experience.scss";
import "@/styles/editorialSystem.scss";
import "./SiteNavigation.scss";

export function SiteNavigation({ currentPath }: { currentPath: string }) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLElement>(null);

  useEffect(() => {
    const chrome = root.current?.querySelector<HTMLElement>(".identity-chrome");
    if (!chrome) return;
    let frame = 0;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        chrome.querySelectorAll<HTMLElement>(".identity-chrome-logo, .identity-chrome-menu")
          .forEach((element) => applyChromeSplitTone(chrome, element));
      });
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previousOverflow; };
  }, [open]);

  return (
    <header ref={root} className="venuex-navigation experienceStage" data-menu-open={open}
      data-chrome-visible="true" data-page-mode="editorial">
      <IdentityChrome menuOpen={open} onToggleMenu={() => setOpen((value) => !value)} />
      <SiteMenuOverlay mode="links" currentPath={currentPath} items={PRIMARY_MENU_LINKS}
        open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
